import './App.css';
import React, { Component } from "react";
import { Snackbar, Grid } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";
import { clearErrors, clearSuccess } from "./actions/ErrorActions";
import LoginPage from './components/LoginPage';
import { connect } from "react-redux";
import { LOGIN_PAGE, MAIN_PAGE } from './actions/RouteActions';
import MainPage from './components/MainPage';
import { autoLogin } from './actions/LoginActions';
import { ClipLoader } from 'react-spinners';

const NO_AUTO_LOGIN = [
    LOGIN_PAGE
]

class App extends Component {

  constructor(props) {
    super(props);
    this.renderPage = this.renderPage.bind(this);
    this.renderSuccess = this.renderSuccess.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
    this.closeError = this.closeError.bind(this);
  } 

  closeError(e) {
    const { dispatch } = this.props;
    dispatch(clearErrors());
    dispatch(clearSuccess());
  }


  async componentDidMount() {
    const { dispatch } = this.props;
    setInterval(async () => {
      const { pageNo } = this.props;
      if (!NO_AUTO_LOGIN.includes(pageNo)) {
        dispatch(autoLogin());
      }
    }, 5000);
  }

  renderErrors() {
    const { errors } = this.props;

    return (
      <React.Fragment>
        {errors.map((error) => {
          return (
            <Grid item xs={12}>
              <MuiAlert elevation={6} variant="filled" severity="error">
                {error}
              </MuiAlert>
            </Grid>
          );
        })}
      </React.Fragment>
    );
  }

  renderSuccess() {
    const { successMessage } = this.props;

    return (
      <React.Fragment>
        <MuiAlert elevation={6} variant="filled" severity="success">
          {successMessage}
        </MuiAlert>
      </React.Fragment>
    );
  }


  renderPage() {
    const { pageNo } = this.props;
    switch(pageNo) {
        case LOGIN_PAGE:
          return <LoginPage/>
        case MAIN_PAGE:
          return <MainPage/>
        default:
          return <React.Fragment/>
    }
  }

  render() {

    const { errors, successMessage, loading } = this.props;

    const mainClass = (loading ? " loading_overlay" : "");

    return (
      <div className='App'>
        {loading ? <ClipLoader size={300} color='red' className='loading_spinner'/> : <React.Fragment/>}
        <div className={mainClass}>
          {this.renderPage()}
          <Snackbar
            open={errors.length > 0 || successMessage}
            autoHideDuration={4000}
            onClose={this.closeError}
          >
            <Grid container spacing={2}>
              {errors.length > 0 ? this.renderErrors() : <React.Fragment />}
              {successMessage ? this.renderSuccess() : <React.Fragment />}
            </Grid>
          </Snackbar>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pageNo: state.routes.pageNo,
  args: state.routes.args,
  errors: state.error.errors,
  successMessage: state.error.successMessage,
  loading: state.loading.loading
});

export default connect(mapStateToProps)(App);
